<template>
    <nav>
        <v-app-bar flat absolute app>
            <v-toolbar-title class="text-uppercase accent--text">
                <span class="font-italic font-weight-light">Revi </span>
                <span class="font-weight-bold">FAST</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text color="accent">F.A.Q.</v-btn>
            <v-btn text color="accent">Afiliados</v-btn>
            <v-btn text color="accent">Promociones</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="font-weight-bold text subtitle-2" outlined color="primary">
                <span>Registro </span>
                <v-icon right>input</v-icon>
            </v-btn>
        </v-app-bar>


    </nav>
</template>

<script>
export default {
    data(){
        return{
           
        }
    }


}
</script>